export const environment = {
    production: false,
    hmr: false,
    useStubs: false,
    getTokenUrl: '',
    keepAliveUrl: '',
    applicationInsightsKeyUrl: '',
    tekstenUrl: '',
    graphQLUrl: '',
    siteSettingsUrl: '',
    veiligheidsMeterUrl: '',
    availableVMModulesUrl: '',
    vmModuleUrl: '',
    vmStoreVMUrl: '',
    vmGetScore: ''
};
